import React, { useEffect, Suspense, lazy, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Cookies from 'js-cookie';
import PageLoading from '../components/common/spinners/PageLoading'
import NotFound from '../pages/not-found/NotFound '
import InstallationPage from '../components/common/page/InstallationPage';
import ViewEnquiryForm from '../pages/enquiry/view-enquiry-form/ViewEnquiryForm';
import InstallationCalendar from '../pages/installation/calendar/InstallationCalendar';
import Settings from '../pages/installation/settings/Settings';

const Prospects = lazy(() => import('../pages/installation/prospects/Prospects'))
const ProspectView = lazy(() => import('../pages/installation/view-prospect/ViewProspect'))
const MyBucket = lazy(() => import('../pages/installation/my-bucket/MyBucket'))
const ViewInstall = lazy(() => import("../pages/installation/view-install/ViewInstall"))
const ScheduleCall = lazy(() => import("../pages/installation/schedule-call/ScheduleCall"))
const InstallationForm = lazy(() => import('../pages/installation/i-form/InstallationForm'))
const Home = lazy(() => import('../pages/installation/home/Home'))
const SearchProspect = lazy(() => import('../pages/lead/search-prospect/SearchProspect'))
const SingleProspectView = lazy(() => import('../pages/lead/search-prospect/ViewProspect'))
const ReWorkForm = lazy(() => import('../pages/installation/re-work/ReWorkForm'))

const InstallRouter = () => {
    let isAuthenticated = false
    const [pageHead, setPageHead] = useState({ title: null, desc: null })
    const rfs_tkn = Cookies.get('_rfs_tkn');
    const DVC_ID = Cookies.get('DVC_ID');


    if (DVC_ID && rfs_tkn) {
        isAuthenticated = true
    }

    useEffect(() => {
        // Change Title
        document.title = `Installation | Sales App | Alliance`;

        // eslint-disable-next-line
    }, [])


    return (
        <InstallationPage pageHead={pageHead}>

            <Suspense fallback={<PageLoading />}>
                <Routes>

                    {/* Home */}
                    <Route path='/' element={<PrivateRoute element={<Home setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Prospects */}
                    <Route path='/prospects-queue' element={<PrivateRoute element={<Prospects setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospects-queue/:prospect_id' element={<PrivateRoute element={<ProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Bucket */}
                    <Route path='/bucket-list' element={<PrivateRoute element={<MyBucket setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:installation_id' element={<PrivateRoute element={<ViewInstall setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:installation_id/schedule' element={<PrivateRoute element={<ScheduleCall setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Installation Attend */}
                    <Route path='/bucket-list/:prospect_id/:installation_id/attend' element={<PrivateRoute element={<InstallationForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    <Route path='/e-form/:e_form_srl_no' element={<PrivateRoute element={<ViewEnquiryForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Calendar */}
                    <Route path='/calendar/:view/:theYear/:theMonth/:theDate' element={<PrivateRoute element={<InstallationCalendar setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Home */}
                    <Route path='/prospect/search' element={<PrivateRoute element={<SearchProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospect/:prospect_id/view' element={<PrivateRoute element={<SingleProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Rework */}
                    <Route path='/re-work' element={<PrivateRoute element={<ReWorkForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Settings */}
                    <Route path='/settings' element={<PrivateRoute element={<Settings setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* 404 Route */}
                    <Route path="/*" element={<NotFound setPageHead={setPageHead} />} />
                </Routes>
            </Suspense>
        </InstallationPage>
    )
}

export default InstallRouter


function PrivateRoute({ element, isAuthenticated, }) {
    return isAuthenticated ? element : window.location.href = 'https://staff.alliancewatersolutions.com/?page=home';
}

